<template>
  <div>
    <table class="table table-responsive-md mb-2">
      <thead>
      <tr>
        <th scope="col" class="cursor-pointer">
          {{ $t('validations.create.status_label') }}
        </th>
        <th scope="col" class="cursor-pointer">
          {{ $t('validations.create.owner_label') }}
        </th>
        <th scope="col" class="cursor-pointer">
          {{ $t('validations.create.comment_label') }}
        </th>
        <th scope="col" class="cursor-pointer">
          {{ $t('validations.create.date_label') }}
        </th>
        <th width="150" v-if="tableItems.length"></th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="validation in tableItems" :qid="'validations-list-item' + type">
          <td>
            <span v-if="validation.validation === 1" :qid="'validations-status-approved-' + type">
              <font-awesome-icon icon="check-circle" class="icon-success"/>
              {{ $t('system.approved') }}
            </span>
            <span v-if="validation.validation === 0" :qid="'validations-status-rejected' + type">
              <font-awesome-icon icon="times-circle" class="icon-danger"/>
              {{ $t('system.rejected') }}
            </span>
          </td>
          <td>
            <img v-if="validation.updated_by"
                 v-bind:src="getUserAvatar(validation.updated_by)"
                 class="rounded-circle mr-3"
                 width="30"
                 height="30"
                 qid="profile-photo"
            >
            <span v-if="validation.updated_by">{{ validation.updated_by.name }}</span>
          </td>
          <td>{{ validation.comment | truncate(50)}}</td>
          <td>{{ validation.created_at | formatDate }}</td>
          <td>
            <button @click="showViewModal(validation)"
                    class="btn btn-link btn-xs mr-3"
                    :qid="'validations-view-modal-' + type"
            >
              {{ $t('system.view_more') }}
            </button>
          </td>
        </tr>
        <tr v-if="!loading && !tableItems.length" :qid="'no-results-row' + type" class="text-center">
          <td colspan="10">
            {{ $t('system.no_results') }}
          </td>
        </tr>
      </tbody>
    </table>


    <!-- View validation modal template -->
    <b-modal ref="view-validation" hide-footer @hide="hideViewModal">
      <div class="d-block text-center">
        <h4 qid="delete-validation-title">
          {{ $t('validations.view.title') }}
        </h4>
      </div>
      <div class="d-block">
        <label qid="create-validation-status-label" class="mt-3">
          {{ $t('validations.create.status_label') }}
        </label>
        <br>
        <span v-if="itemToView.validation === 1" qid="validations-status-approved">
          <font-awesome-icon icon="check-circle" class="icon-success"/>
          {{ $t('system.approved') }}
        </span>
        <span v-if="itemToView.validation === 0">
          <span class="badge-pill badge-danger mr-2" qid="validations-status-rejected">
            <font-awesome-icon icon="times" size="xs"/>
          </span>
          {{ $t('system.rejected') }}
        </span>
        <br>
        <label qid="create-validation-comment-label" class="mt-4">
          {{ $t('validations.create.comment_label') }}
        </label>
        <br>
        <span class="text-formatted">
          {{ itemToView.comment }}
        </span>
        <br>
        <b-form-group class="mt-2" v-if="!_.isEmpty(itemToView.checklist)">
          <label qid="create-validation-checklist-label" class="mt-3">
            {{ $t('validations.create.checklist_label') }}
          </label>
          <div class="row" v-if="itemToView.checklist">
            <div v-for="(value,key) in itemToView.checklist" class="col-sm-12">
              <p class="mt-2">
                {{ $t('validations.checklist.' + $options.filters.slugify(key)) }}
              </p>
              <div v-for="(itemValue,itemKey) in value" class="row">
                <div class="col-sm-6">
                  <p class="text-normal smaller">
                    {{ $t('validations.checklist.' + $options.filters.slugify(itemKey)) }}
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  {{ $t('system.' + $options.filters.slugify(itemValue)) }}
                </div>
              </div>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="itemToView.media && itemToView.media.length">
          <label qid="create-validation-media-label" class="mt-3">
            {{ $t('validations.create.attachments_label') }}
          </label>
          <p v-for="item in itemToView.media">
            <span class="float-right text-muted cursor-pointer"
                  @click="downloadMedia(item)"
                  qid="download-media"
            >
              <font-awesome-icon icon="cloud-download-alt" />
            </span>
            <a @click="downloadMedia(item)" qid="download-media-button">
              {{ item.file_name }}
            </a>
          </p>
        </b-form-group>
        <b-form-group v-if="itemToView.links && itemToView.links.length">
          <label qid="create-validation-links-label" class="mt-3">
            {{ $t('validations.create.links_label') }}
          </label>
          <div v-if="itemToView.links">
            <p v-for="link in itemToView.links">
              <a :href="link.url" target="_blank" qid="create-tp-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </p>
          </div>
        </b-form-group>
      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="success"
                  @click="hideViewModal"
                  qid="view-validation-cancel-button"
        >
          {{ $t('validations.view.close') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import {initialsAvatarUrl} from '@/util/userAvatar.js';
  import piincHttp from '@/util/configureAxios.js'
  import {config} from '@/config.js'

  export default {
    name: 'ValidationList',
    props: {
      object: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: false
      },
      reloadList: {
        type: Boolean
      }
    },
    data: function() {
      return {
        tableItems: [],
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        itemToDelete: {},
        itemToView: {},
        validationForm: {
          validation: '',
          comment: '',
          links: [],
          checklist: {}
        },
        validationOptions: [
          {text: this.$t('validations.create.status_accepted'), value: true},
          {text: this.$t('validations.create.status_rejected'), value: false},
        ],
        checklistOptions: [
          {text: this.$t('system.yes'), value: 'Yes'},
          {text: this.$t('system.no'), value: 'No'},
          {text: this.$t('system.n_a'), value: 'N/A'},
        ],
        error: '',
        selectedFiles: [],
        inputLink: '',
        loading: true
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
    },
    watch: {
      // Watch when prop changes and then load validations
      object: function (value) {
        if (value && value.who_am_i) {
          this.loadValidations()
        }
      },
      reloadList: function (value) {
        if (value) {
          this.loadValidations()
        }
      },

    },
    methods: {
      loadValidations(page) {
        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let self = this;
        piincHttp.get('validations', { params:
          {
            page: pageNumber,
            model_type: this.object.who_am_i,
            model_id: this.object.id,
            type: this.type,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
          self.$emit('validationListUpdated', self.tableItems[0]);
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      onFileChange() {
        let files = document.querySelector('#file-validation');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.validationForm.links.push(this.inputLink)
          // Reset link input form
          this.inputLink = ''
        }
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.validationForm.links.splice(index, 1);
      },
      pageChanged(page) {
        // Load validation when page changed listener is triggered
        this.loadValidations(page)
      },
      showViewModal(object) {
        this.itemToView = object
        if (object.checklist) {
          // Try to create object from string, if checklist is string
          try {
            this.itemToView.checklist = JSON.parse(object.checklist)
          } catch (e) {}
        }
        // If already object, just proceed to open the modal
        this.$refs['view-validation'].show()
      },
      hideViewModal() {
        this.itemToView = {};
        this.$refs['view-validation'].hide()
      },
      getUserAvatar(user){
        if (user && user.avatar) {
          return user.avatar;
        } else {
          return initialsAvatarUrl(user);
        }
      },
    },
    created() {
      if (this.object && this.object.who_am_i) {
        this.loadValidations()
      }
    }
  }
</script>
